import { CdpEuiccAuditListParameters, CdpEuiccAuditListResponse, CdpEuiccAuditListResult } from "../app/shared/models/layout/cdp/euicc/audit/list/CdpEuiccAuditList";

export function response(params: CdpEuiccAuditListParameters): CdpEuiccAuditListResponse {

  let result = data.filter(d => d.eid === params.eid);
  if (params.sort) {
    let order = params.sort.charAt(0);
    let sort = params.sort.slice(1);
    result = result.sort((a,b) =>  order === "+" ? a[sort].localeCompare(b[sort]) : b[sort].localeCompare(a[sort]));
  }

  let response: CdpEuiccAuditListResponse = {
    cmd: {
      success: true,
      errorMessage: undefined,
      params:{
          count: result.length,
          result: result.slice(params.offset, params.offset + params.limit)
      }
    }
  }
  return response;
}

const data: CdpEuiccAuditListResult[] = [
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "aaaaaaaaaaaaaaaaa",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "bbbbbbbbbbbbb",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "sdfasdfsadfsda",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "sdfdsssssss",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "sdfdasffff",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "usera@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "teeeser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456ssds789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user14556@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'fallbackIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'fallbackIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'fallbackIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "aaaaa9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  }, {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345649",
    value: "89098765432107654322",
    ts: "2203-06-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user9@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345601",
    value: "89098765432107654323",
    ts: "2204-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user5@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345602",
    value: "89098765432107654324",
    ts: "2202-08-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "tser3@example.com"
  },
  {
    id: "55914c7c74e00c48b400002b",
    orgId: "789012345678901234567890",
    eid: "89040024000002593200010000007090",
    field: 'activeIccid',
    priorValue: "89123456789012345600",
    value: "89098765432107654321",
    ts: "2202-07-01T12:34:56.789Z",
    status: "Changed",
    whoAmI: "user1@example.com"
  }
]
